import React from 'react'

import Icon from '../../Icon/Icon'

const NextLinkElement = () => (
  <span>
    Next
    <Icon type="chevron-right" />
  </span>
)

export default NextLinkElement
